import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import { LazyLoadPlaceholder } from '../../components/common/lazyLoadPlaceholder/lazyLoadPlaceholder';

export const LazyLoadImg = memo(({ alt,
                              style,
                              src,
                              width,
                              height,
                              useIntersectionObserver=true,
                              threshold=100,
                              placeholderSrc,
                              placeholder=<LazyLoadPlaceholder />,
                              handleImageLoadError }) => {
    return (
        <LazyLoadImage
          alt={alt}
          style={style}
          src={src}
          width={width}
          height={height}
          placeholder={placeholder}
          placeholderSrc={placeholderSrc}
          useIntersectionObserver={useIntersectionObserver}
          threshold={threshold}
          onError={handleImageLoadError} />
    )
});

LazyLoadImg.displayName = 'LazyLoadImg';

LazyLoadImg.propTypes = {
    alt: PropTypes.string,
    style: PropTypes.object,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    src: PropTypes.string,
    useIntersectionObserver: PropTypes.bool,
    threshold: PropTypes.number,
    placeholderSrc: PropTypes.string,
    placeholder: PropTypes.func,
    handleImageLoadError: PropTypes.func
};

